import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ReportSection from "./laporan-section";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import useIsMobile from "../../hooks/useIsMobile";

const title = "List Semua Laporan";

const dataMasalah = {
  id: "0",
  title: "Masalah Kendaraan",
  details: [
    {
      id: "0-1",
      title: "Masalah Mobil Kecil & Bus",
      description: "Laporan list masalah kendaraan, khusus mobil kecil & bus",
      url: "/laporan/masalah-mobil",
    },
    {
      id: "0-2",
      title: "Masalah Mobil Dutro",
      description: "Laporan list masalah kendaraan, khusus dutro",
      url: "/laporan/masalah-dutro",
    },
    {
      id: "0-3",
      title: "Masalah Mobil Trado",
      description: "Laporan list masalah kendaraan, khusus head trado",
      url: "/laporan/masalah-trado",
    },
    {
      id: "0-4",
      title: "Masalah Trailer",
      description: "Laporan list masalah trailer",
      url: "/laporan/masalah-trailer",
    },
  ],
};

const dataMasalahPerUnit = {
  id: "1",
  title: "Masalah Kendaraan Per Unit",
  details: [
    {
      id: "1-1",
      title: "Masalah Mobil Kecil & Bus - Per Unit",
      description:
        "Masalah kendaraan, mobil kecil & bus, dikelompokkan per unit",
      url: "/laporan/masalah-mobil-per-unit",
    },
    {
      id: "1-2",
      title: "Masalah Mobil Dutro - Per Unit",
      description: "Masalah kendaraan, dutro, dikelompokkan per unit",
      url: "/laporan/masalah-dutro-per-unit",
    },
    {
      id: "1-3",
      title: "Masalah Mobil Trado - Per Unit",
      description: "Masalah kendaraan, head trado, dikelompokkan per unit",
      url: "/laporan/masalah-trado-per-unit",
    },
    {
      id: "1-4",
      title: "Masalah Trailer - Per Unit",
      description: "Masalah kendaraan, trailer, dikelompokkan per unit",
      url: "/laporan/masalah-trailer-per-unit",
    },
  ],
};

const dataJatuhTempoService = {
  id: "2",
  title: "Jatuh Tempo Service Kendaraan",
  details: [
    {
      id: "1-1",
      title: "Jatuh Tempo Service Mobil Kecil & Bus",
      description:
        "Jatuh tempo service, mobil kecil & bus, berdasarkan kilometer terakhir",
      url: "/laporan/service-mobil-by-km",
    },
    {
      id: "1-2",
      title: "Jatuh Tempo Service Dutro",
      description: "Jatuh tempo service, dutro, berdasarkan kilometer terakhir",
      url: "/laporan/service-dutro-by-km",
    },
    {
      id: "1-3",
      title: "Jatuh Tempo Service Trado",
      description: "Jatuh tempo service, trado, berdasarkan kilometer terakhir",
      url: "/laporan/service-trado-by-km",
    },
  ],
};

const dataService = {
  id: "3",
  title: "History Service Kendaraan",
  details: [
    {
      id: "1-1",
      title: "History Service Mobil Kecil & Bus",
      description:
        "Laporan history service, mobil kecil & bus, berdasarkan kilometer terakhir",
      url: "/laporan/history-service-mobil",
    },
    {
      id: "1-2",
      title: "History Service Dutro",
      description:
        "Laporan history service, dutro, berdasarkan kilometer terakhir",
      url: "/laporan/history-service-dutro",
    },
    {
      id: "1-3",
      title: "History Service Trado",
      description:
        "Laporan history service, trado, berdasarkan kilometer terakhir",
      url: "/laporan/history-service-trado",
    },
  ],
};

const dataPengisianMinyak = {
  id: "4",
  title: "Pengisian Minyak Kendaraan",
  details: [
    {
      id: "4-1",
      title: "Pengisian Minyak Per Kendaraan",
      description:
        "Laporan pengisian minyak kendaraan per unit, berdasarkan tanggal",
      url: "/laporan/pengisian-minyak-per-unit",
    },
    {
      id: "4-2",
      title: "Pengisian Minyak",
      description:
        "Laporan pengisian minyak kendaraan per jenis minyak, berdasarkan tanggal",
      url: "/laporan/pengisian-minyak-per-jenis",
    },
  ],
};

const LaporanMainPage = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, [dispatch]);

  const sections = [
    [dataMasalah, dataMasalahPerUnit],
    [dataJatuhTempoService, dataService],
    [dataPengisianMinyak],
  ];

  if (isMobile) {
    // ✅ MOBILE LAYOUT
    return (
      <div className="flex flex-col w-full h-full p-1 gap-3 bg-slate-50">
        {sections.flat().map((section) => (
          <div
            key={section.id}
            className="row-start-start w-full p-2 gap-4 justify-start"
          >
            <ReportSection {...section} />
          </div>
        ))}
      </div>
    );
  }

  // 💻 DESKTOP LAYOUT
  return (
    <div className="col-start-start w-full h-full p-4">
      {sections.map((row, i) => (
        <section
          key={i}
          className="row-start-start w-full p-4 gap-4 justify-start"
        >
          {row.map((section) => (
            <div key={section.id} className="col-start-start gap-5 grow">
              <ReportSection {...section} />
            </div>
          ))}
        </section>
      ))}
    </div>
  );
};

export default LaporanMainPage;
